import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootState } from '@/store/store';
import { selectMemberLang } from '@/state/member/memberSelectors';
import { useSelector } from 'react-redux';

const useSelectedLanguage = () => {
    const { i18n } = useTranslation();
    const storageLanguage = localStorage?.getItem('lang');
    const memberLang = useSelector((state: RootState) => selectMemberLang(state));
    const browserLang = navigator.language.split('-')[0];

    useLayoutEffect(() => {
        const isLocalStorageAvailable = Boolean(localStorage);

        let currentUserLang = memberLang;

        if (!currentUserLang && storageLanguage) {
            currentUserLang = storageLanguage;
        }

        if (!currentUserLang && !storageLanguage && browserLang) {
            currentUserLang = browserLang;
        }

        if (currentUserLang && isLocalStorageAvailable) {
            localStorage.setItem('lang', memberLang);
        }
        if (i18n.language !== currentUserLang) {
            i18n.changeLanguage(currentUserLang);
        }
    }, [memberLang, i18n, browserLang, storageLanguage]);
    return null;
};

export default useSelectedLanguage;
